<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="24">
        <p>
          <b>Выберите перевозчика из ваших контрагентов:</b>
        </p>
        <span
          v-if="!isSelectContr"
          class="href-select"
          @click="innDialogViewSet"
        >
          Выбрать
        </span>
        <el-dialog
          title="Выбор контрагента"
          :visible.sync="innDialogView"
          :width="isMobile ? '100%' : '50%'"
          append-to-body
          :close-on-click-modal="false"
        >
          <select-contragent @selected="selectContragent" />
        </el-dialog>
        <span v-if="isSelectContr" class="selected-contr">
          Вы выбрали: {{ textContragent }}
          <span
            v-if="!readonly && !isDriverRole"
            class="href-select"
            @click="innDialogViewSet"
          >
            Выбрать другого
          </span>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SelectContragent from '@/components/Contragents/SelectContragent'
import mixinMain from '../Mixins/main'

export default {
  name: 'SetCarrier',
  components: { SelectContragent },
  mixins: [mixinMain],
  props: {
    auto: {
      type: Object,
      default: () => {},
    },
    reason: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      innDialogView: false,
      isSelectContr: false,
      needContract: false,
      textContragent: '',
      returnData: {
        innCarrier: '',
        nameCarrier: '',
      },
    }
  },
  watch: {
    reason() {
      if (this.isAdminOrCeoRole) {
        this.clearCarrier()
      }
    },
    auto: {
      immediate: true,
      handler(auto) {
        if (auto.innCarrier) {
          this.isSelectContr = true
          this.textContragent = this.auto.nameCarrier
          this.returnData.innCarrier = this.auto.innCarrier
          this.returnData.name = this.auto.nameCarrier
        } else if (this.isDriverRole && this.userInfo.current) {
          const { inn, short_name } = this.userInfo.current.organization

          this.isSelectContr = true
          this.textContragent = short_name
          this.returnData.innCarrier = inn
          this.returnData.nameCarrier = short_name

          if (auto.isOwner === 1) {
            this.returnData.innOwner = inn
            this.returnData.nameOwner = short_name
          }
          this.changed()
        } else {
          this.clearCarrier()
        }
      },
    },
  },
  methods: {
    selectContragent(id) {
      this.innDialogView = false
      let contragent = this.$store.getters.getContragent(id)

      this.isSelectContr = true
      this.textContragent = contragent.org_name
      this.returnData.innCarrier = contragent.inn
      this.returnData.nameCarrier = contragent.org_name

      if (this.auto && this.auto.isOwner === 1) {
        this.returnData.innOwner = contragent.inn
        this.returnData.nameOwner = contragent.org_name
      }
      this.changed()
    },
    innDialogViewSet() {
      this.innDialogView = true
    },
    clearCarrier() {
      this.isSelectContr = false
      this.textContragent = ''
      this.returnData.innCarrier = ''
      this.returnData.nameCarrier = ''
    },
  },
}
</script>

<style scoped>
.href-select {
  color: #409eff;
  text-decoration: underline;
  font-family: 'Rubik Medium', sans-serif;
  font-size: 14px;
  cursor: pointer;
}
.href-select:hover {
  text-decoration: none;
}
.selected-contr {
  font-size: 14px !important;
  color: #b5b5b5;
  font-family: 'Rubik Medium', sans-serif;
}
</style>
